module.exports = __webpack_public_path__ + "media/04d.ab304475.mp4";